<template>
  <div class="mb-2">
    <label :for="id" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">{{ label }}</label>
    <textarea
      :id="id"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      :class="textareaClasses"
      :placeholder="placeholder"
      :required="required"
      :disabled="disabled"
      class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
    ></textarea>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    label: String,
    id: String,
    textareaClasses: String,
    placeholder: String,
    required: Boolean,
    disabled: {
      type: Boolean,
      default: false
    },
  },
};
</script>

<style scoped>
/* Add your styles here */
</style>
